var _g, _g2, _g3, _path, _line, _line2, _line3, _line4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _g5, _g6, _g7, _g8, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 127,
    viewBox: "0 0 209 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1133_1448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 6.89543 0.895431 6 2 6H196.054C197.158 6 198.054 6.89543 198.054 8V104.143H0V8Z",
    fill: "url(#paint0_radial_1133_1448)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.165 8C0.165 6.98656 0.986557 6.165 2 6.165H196.054C197.067 6.165 197.889 6.98656 197.889 8V103.978H0.165V8Z",
    stroke: "#455E52",
    strokeWidth: 0.330001
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_1133_1448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.333 2C44.333 0.895432 45.2284 0 46.333 0H202.054C203.158 0 204.054 0.895431 204.054 2V93.1392C204.054 94.2438 203.158 95.1392 202.054 95.1392H46.333C45.2284 95.1392 44.333 94.2438 44.333 93.1392V2Z",
    fill: "url(#paint1_radial_1133_1448)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_1133_1448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.333 2C44.333 0.89543 45.2284 0 46.333 0H202.054C203.158 0 204.054 0.895431 204.054 2V9.52435H44.333V2Z",
    fill: "url(#paint2_radial_1133_1448)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.333 6L38.333 101.139",
    stroke: "#455E52",
    strokeWidth: 0.330001
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.04965,
    y1: 24.0213,
    x2: 31.2849,
    y2: 24.0213,
    stroke: "url(#paint3_linear_1133_1448)",
    strokeWidth: 1.32,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.04965,
    y1: 43.1209,
    x2: 31.2849,
    y2: 43.1209,
    stroke: "url(#paint4_linear_1133_1448)",
    strokeWidth: 1.32,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.04965,
    y1: 63.4757,
    x2: 31.2849,
    y2: 63.4757,
    stroke: "url(#paint5_linear_1133_1448)",
    strokeWidth: 1.32,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.04965,
    y1: 83.0509,
    x2: 31.2849,
    y2: 83.0509,
    stroke: "url(#paint6_linear_1133_1448)",
    strokeWidth: 1.32,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9962 84.0072H195.273",
    stroke: "#293831",
    strokeWidth: 0.718742
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0598 14.8672L52.0598 85.1939",
    stroke: "#293831",
    strokeWidth: 0.718742
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8782 26.3032H52.0598",
    stroke: "#293831",
    strokeWidth: 0.718742
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8782 41.5822H52.0598",
    stroke: "#293831",
    strokeWidth: 0.718742
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8782 56.8611H52.0598",
    stroke: "#293831",
    strokeWidth: 0.718742
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8782 72.14H52.0598",
    stroke: "#293831",
    strokeWidth: 0.718742
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.391 68.6074L56.6259 66.1051L61.4132 68.6074L64.8195 66.1051H68.1338L94.2797 58.1811L109.654 57.764L134.051 47.9633L154.029 35.4518H161.854L172.81 28.1534L184.041 23.3573L191.038 18.7698L195.116 17.1632L195.181 17.1016L195.273 18.1442V83.6212H52.391V68.6074Z",
    fill: "url(#paint7_linear_1133_1448)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0956 68.4871L56.342 66.013L61.1422 68.4871L64.5578 66.013H67.8811L94.098 58.1781L109.514 57.7657L133.977 48.0752L154.009 35.7044H161.856L172.841 28.4881L184.103 23.7459L191.119 19.2099L195.208 17.6214L195.273 17.5605",
    stroke: "url(#paint8_linear_1133_1448)",
    strokeWidth: 0.718742
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1133_1448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7902,
    cy: 58.5285,
    rx: 2.23432,
    ry: 2.2343,
    fill: "url(#paint9_linear_1133_1448)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1133_1448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.427,
    cy: 35.5427,
    rx: 2.23432,
    ry: 2.2343,
    fill: "url(#paint10_linear_1133_1448)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1133_1448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.572,
    cy: 47.3614,
    rx: 2.23432,
    ry: 2.2343,
    fill: "url(#paint11_linear_1133_1448)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1133_1448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.3188,
    cy: 66.1199,
    rx: 2.23432,
    ry: 2.2343,
    fill: "url(#paint12_linear_1133_1448)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1133_1448)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.273,
    cy: 17.1016,
    rx: 2.23432,
    ry: 2.2343,
    fill: "url(#paint13_linear_1133_1448)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.165 101.304H197.889V124.611C197.889 125.625 197.067 126.446 196.054 126.446H2C0.986558 126.446 0.165 125.625 0.165 124.611V101.304Z",
    fill: "#293831",
    stroke: "#455E52",
    strokeWidth: 0.330001
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5809 117.868C97.7862 117.868 99.5739 116.081 99.5739 113.875C99.5739 111.67 97.7862 109.882 95.5809 109.882C93.3756 109.882 91.5879 111.67 91.5879 113.875C91.5879 116.081 93.3756 117.868 95.5809 117.868Z",
    stroke: "#455E52",
    strokeWidth: 0.660001
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0434 6.26221V5.90647H48.6133V4.08421H48.0434V3.72847H49.6551V4.08421H49.0852V5.90647H49.6551V6.26221H48.0434ZM50.6229 4.44358H50.5866V6.26221H50.18V3.72847H50.7645L51.4288 5.5471H51.4651V3.72847H51.8716V6.26221H51.2872L50.6229 4.44358ZM52.8685 6.26221L52.1751 3.72847H52.6978L53.0137 5.00986L53.1988 5.80846H53.2242L53.413 5.00986L53.7324 3.72847H54.2297L53.5364 6.26221H52.8685ZM54.5913 6.26221V3.72847H56.1921V4.12051H55.0668V4.78117H56.1522V5.17321H55.0668V5.87017H56.1921V6.26221H54.5913ZM57.5265 6.30577C57.3087 6.30577 57.1224 6.26826 56.9675 6.19324C56.8151 6.11822 56.6904 6.019 56.5936 5.89558L56.8804 5.59792C56.9748 5.70682 57.0764 5.78789 57.1853 5.84113C57.2966 5.89195 57.4152 5.91736 57.5411 5.91736C57.6863 5.91736 57.7976 5.88469 57.875 5.81935C57.9525 5.75401 57.9912 5.65963 57.9912 5.53621C57.9912 5.43457 57.9621 5.35834 57.9041 5.30752C57.846 5.25428 57.748 5.21677 57.61 5.19499L57.3414 5.15143C57.1067 5.11029 56.9397 5.02559 56.8405 4.89733C56.7412 4.76665 56.6916 4.61298 56.6916 4.43632C56.6916 4.19432 56.7703 4.00919 56.9276 3.88093C57.0849 3.75025 57.3027 3.68491 57.581 3.68491C57.7794 3.68491 57.95 3.71637 58.0928 3.77929C58.238 3.84221 58.3542 3.92812 58.4413 4.03702L58.1618 4.33468C58.094 4.25482 58.013 4.1919 57.9186 4.14592C57.8242 4.09752 57.7129 4.07332 57.5846 4.07332C57.3087 4.07332 57.1708 4.18706 57.1708 4.41454C57.1708 4.51134 57.1998 4.58515 57.2579 4.63597C57.316 4.68679 57.4152 4.7243 57.5556 4.7485L57.8206 4.79569C58.0408 4.83683 58.2041 4.9179 58.3106 5.0389C58.4171 5.1599 58.4703 5.31478 58.4703 5.50354C58.4703 5.62212 58.4498 5.73102 58.4086 5.83024C58.3675 5.92704 58.307 6.01174 58.2271 6.08434C58.1473 6.15452 58.048 6.20897 57.9295 6.24769C57.8133 6.28641 57.679 6.30577 57.5265 6.30577ZM59.9681 4.12051V6.26221H59.4962V4.12051H58.7339V3.72847H60.7304V4.12051H59.9681Z",
    fill: "#FAF7F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1133_1448",
    x: -15.84,
    y: -9.84003,
    width: 229.734,
    height: 129.823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_1448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1133_1448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_1133_1448",
    x: 28.493,
    y: -15.84,
    width: 191.401,
    height: 126.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_1448"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.219608 0 0 0 0 0.192157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1133_1448",
    result: "effect2_dropShadow_1133_1448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1133_1448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_1133_1448",
    x: 28.493,
    y: -15.84,
    width: 191.401,
    height: 41.2044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_1448"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.219608 0 0 0 0 0.192157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1133_1448",
    result: "effect2_dropShadow_1133_1448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1133_1448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1133_1448",
    x: 87.6809,
    y: 56.2942,
    width: 10.2186,
    height: 10.2186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.87497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43748
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1133_1448",
    x: 149.318,
    y: 33.3084,
    width: 10.2186,
    height: 10.2186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.87497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43748
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1133_1448",
    x: 129.463,
    y: 45.1271,
    width: 10.2186,
    height: 10.2186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.87497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43748
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1133_1448",
    x: 51.2095,
    y: 63.8856,
    width: 10.2186,
    height: 10.2186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.87497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43748
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1133_1448",
    x: 190.164,
    y: 14.8672,
    width: 10.2186,
    height: 10.2186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.87497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43748
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1133_1448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8357 18.4594) rotate(23.8473) scale(187.218 321.128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1133_1448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6844 12.0781) rotate(27.984) scale(156.376 300.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1133_1448",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.054 9.52435) rotate(-176.587) scale(160.004 39.3682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1133_1448",
    x1: 6.38965,
    y1: 24.6813,
    x2: 33.7532,
    y2: 24.6813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1133_1448",
    x1: 6.38965,
    y1: 43.7809,
    x2: 33.7532,
    y2: 43.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1133_1448",
    x1: 6.38965,
    y1: 64.1357,
    x2: 33.7532,
    y2: 64.1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1133_1448",
    x1: 6.38965,
    y1: 83.7109,
    x2: 33.7532,
    y2: 83.7109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1133_1448",
    x1: 124.661,
    y1: 50.2571,
    x2: 124.661,
    y2: 83.6212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57233",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1133_1448",
    x1: 195.365,
    y1: 17.2931,
    x2: 45.3737,
    y2: 24.9801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3460A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1133_1448",
    x1: 92.7902,
    y1: 56.2942,
    x2: 92.7902,
    y2: 60.7628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1133_1448",
    x1: 154.427,
    y1: 33.3084,
    x2: 154.427,
    y2: 37.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1133_1448",
    x1: 134.572,
    y1: 45.1271,
    x2: 134.572,
    y2: 49.5957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1133_1448",
    x1: 56.3188,
    y1: 63.8856,
    x2: 56.3188,
    y2: 68.3542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1133_1448",
    x1: 195.273,
    y1: 14.8672,
    x2: 195.273,
    y2: 19.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.30bf5dc0dfe7bb189f6c0d429848294c.svg";
export { ForwardRef as ReactComponent };